import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";
import dataService from "../../api";


export default {
    namespaced: true,
    state: {
        specializations: [],
       
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.specializations.findIndex(i => i.id === id)
    },
    mutations: {
        SET_specializations: (state, data) => state.specializations = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.specializations.getAll(paramsString);
                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                commit('SET_specializations', response.data.specializations);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
     
    },
};
